module.exports = __webpack_public_path__ + "img/unlock.da5be216.svg";